import React from 'react';

export default function AgentAvailabilityWidget({ agents = [] }) {
  if (!agents.length) {
    return (
      <div style={{ textAlign: 'center', padding: '24px 0', color: '#718096', fontSize: 13 }}>
        No agent data available
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {agents.slice(0, 8).map((agent, i) => {
        // Support both { name, status } and { label, lastActive } shapes
        const name = agent.name || agent.label || '—';
        // Prefer server-computed flag (avoids timestamp timezone mismatches)
        const isOnline = (() => {
          if (typeof agent.isOnline === 'boolean') return agent.isOnline;
          if (agent.status) return agent.status === 'online';
          if (agent.lastActive) {
            return (Date.now() - new Date(agent.lastActive).getTime()) < 15 * 60 * 1000;
          }
          return false;
        })();

        return (
          <div
            key={i}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: i < agents.slice(0, 8).length - 1 ? '1px solid #F0F2F5' : 'none',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                background: isOnline ? '#22c55e' : '#C8CDD6',
                boxShadow: isOnline ? '0 0 6px rgba(34,197,94,0.5)' : 'none',
              }} />
              <span style={{ fontSize: 12.5, color: '#1A202C', fontWeight: 600 }}>{name}</span>
            </div>
            <span style={{
              fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 99,
              background: isOnline ? '#DCFCE7' : '#F1F5F9',
              color: isOnline ? '#16a34a' : '#718096',
            }}>
              {isOnline ? 'Online' : 'Offline'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
